import React from 'react'
import { AdvancedFilter } from 'components/Filter/AdvancedFilter'
import { AssetTransferByLocationDetail } from './AssetTransferByLocationDetail/AssetTransferByLocationDetail'
import { AssetTransferByLocationForm } from './AssetTransferByLocationForm/AssetTransferByLocationForm'
import { AssetTransferByLocationMain } from './AssetTransferByLocationMain'

const assetTransferByLocationRoutes = [
  /* -------------------------------------------- */
  /*                ADVANCED FILTER               */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/asset-transfer-by-location/filter',
    },
    component: (
      <AdvancedFilter
        mode="assets-change"
        app="fixed-assets"
        hasStatus
        hasDocDate
        hasDateRange
      />
    ),
  },

  /* -------------------------------------------- */
  /*                     MAIN                     */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/asset-transfer-by-location',
    },
    component: <AssetTransferByLocationMain />,
  },

  /* -------------------------------------------- */
  /*                     FORM                     */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/asset-transfer-by-location/add',
    },
    component: (
      <AssetTransferByLocationForm formMode="add" />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/asset-transfer-by-location/:AssetTransferByLocationID/edit',
    },
    component: <AssetTransferByLocationForm formMode="edit" />,
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/asset-transfer-by-location/:AssetTransferByLocationID/resubmit',
    },
    component: <AssetTransferByLocationForm formMode="resubmit" />,
  },

  /* -------------------------------------------- */
  /*                    DETAIL                    */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/asset-transfer-by-location/:AssetTransferByLocationID/detail',
    },
    component: <AssetTransferByLocationDetail />,
  },
]

export default assetTransferByLocationRoutes
